import { Injectable } from '@angular/core';
import { LoginService as BlueprintLoginService } from '@capturum/login';

@Injectable()
export class LGELoginService extends BlueprintLoginService {
  public onLoginSuccess(response: any): void {
    if (!response) {
      return;
    }

    const isTwoFactorResponse = Object.hasOwn(response, 'method');

    if (isTwoFactorResponse) {
      // 2FA flow — AuthService.onSuccessfulLogin() owns the redirect.
      return;
    }

    const redirectUrl = this.activatedRoute.snapshot.queryParams['redirectUrl'];

    this.router.navigate([redirectUrl || '/dashboard']);
  }
}
